const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID
const scope =
  'public_profile,pages_read_engagement,pages_manage_posts,pages_manage_engagement,read_insights,pages_show_list,business_management,pages_manage_metadata,pages_read_user_content,pages_manage_ads,instagram_basic,ads_management,'
const facebookSDKId = 'facebookSDK'

export const initFacebookSdk = () =>
  new Promise((resolve) => {
    // wait for facebook sdk to initialize before starting the react app
    // window.fbAsyncInit = () => {
    //   window.FB.init({
    //     appId: facebookAppId,
    //     cookie: true,
    //     xfbml: true,
    //     version: 'v9.0',
    //     status: true
    //   })

    //   resolve()
    // }

    // load facebook sdk script
    ;(() => {
      const fbRoot = document.getElementById('fb-root');
      if(fbRoot){
        fbRoot.remove()
      }

      const facebookSDKScript = document.createElement('script')
      facebookSDKScript.id = facebookSDKId
      facebookSDKScript.async = true
      facebookSDKScript.defer = true
      facebookSDKScript.crossOrigin = 'anonymous'
      facebookSDKScript.src = 'https://connect.facebook.net/en_US/sdk.js'
      document.body.append(facebookSDKScript)
//TODO add by gaofeng on 2022/9/13 16:13 Remove status
      facebookSDKScript.onload = ()=>{
        window.FB.init({
          appId: facebookAppId,
          cookie: true,
          xfbml: true,
          version: 'v19.0'
        })
         resolve()
      }
    })()
  })

export const removeFacebookSDKScript = () => {
  const facebookSDKScript = document.getElementById(facebookSDKId)
  facebookSDKScript.remove()
  delete window.FB
  delete window.fbAsyncInit
}

export const connectFacebookPage = () =>
  new Promise((resolve, reject) => {
    window.FB.login(
      (response) => {
        const { authResponse } = response
        authResponse ? resolve(response) : reject(response)
      },
      { scope }
    )
  })
